import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll() {
    document.addEventListener(
      "turbo:frame-load",
      () => window.scrollTo({ top: 0, behavior: "smooth" }),
      { once: true }
    )
  }
}
